import { render, staticRenderFns } from "./ClientHeader.vue?vue&type=template&id=d1a89b7e"
import script from "./ClientHeader.vue?vue&type=script&lang=js"
export * from "./ClientHeader.vue?vue&type=script&lang=js"
import style0 from "./ClientHeader.vue?vue&type=style&index=0&id=d1a89b7e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_f33b182414a87044fb4ff91041025cb4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports